/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */


import Api from '@/services/api';
import AppService from '@/services/app';
import Store from '@/store/index';

export default {
  resetStore() {
    // reset store to empty
    Store.dispatch('adhocMaintenance/setAdhocMaintenanceItems', {
      adhocMaintenance: [],
    });
  },

  async listAll(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['adhocMaintenance/adhocMaintenance'].length < 1) {
      try {
        const response = await Api(true).get('/adhoc_maintenance/list_all');

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetStore();
            return response.data.message;
          } else {
            Store.dispatch('adhocMaintenance/setAdhocMaintenanceItems', {
              adhocMaintenance: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetStore();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('adhocMaintenance.ts - listAll - 46 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  create(params: {
    dateReported: string,
    jobCard?: number,
    vehicle1Id: number,
    vehicle2Id?: number,
    description: string,
    
  }) {
    return Api(true).post('/adhoc_maintenance/create', params);
  },

  updateDescription(params: {
    id: number,
    description: string,
  }) {
    return Api(true).post('/adhoc_maintenance/update_description', params);
  },

  delete(params: {
    id: number,
  }) {
    return Api(true).post('/adhoc_maintenance/delete', params);
  },

};
